const initialState = {
    AllThirdPartyOrg: [],
  }
  const ThirdPartyOrgReducer = (state = initialState, action: { type: any; payload: any; }) => {

    switch (action.type) {
      case 'GET_ALL_THIRDPARTY_ORG':
            return {
                ...state,
                AllThirdPartyOrg: action.payload,
            };
    
        default:
            return state;
    }
  }
  
  export default ThirdPartyOrgReducer;